import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store'

Vue.use(VueRouter)

const requireAuth = () => (from, to, next) => {
    if (store.getters.getIsAuth) return next() // isAuth === true면 페이지 이동
    store.state.nextRoute = from.path
    next('/login') // isAuth === false면 다시 로그인 화면으로 이동
}

export default new VueRouter({
    mode: 'history',
    base: '/',
    routes: [
        {
            //메인
            path: '/',
            name: 'Home',
            component: require('@/components/Home').default,
            meta: {
                layout: 'home'
            }
        },
        {
            //캐스팅엔 유입 메인
            path: '/castingn',
            name: 'Home',
            component: require('@/components/Home').default,  
            props: (route) => ({ castingn: true }),
            meta: {
                layout: 'home' 
            }
        },
        {
            //서비스 이용약관
            path: '/agreement',
            name: 'Agreement',
            component: () => import('@/components/content/Agreement'),
        },
        {
            //개인정보취급방침
            path: '/privacy',
            name: 'Privacy',
            component: () => import('@/components/content/Privacy'),
        },
        {
            //공지사항_리스트
            path: '/notice',
            name: 'NoticeList',
            component: () => import('@/components/content/NoticeList'),
        },
        {
            //공지사항_상세
            path: '/notice/:uuid',
            name: 'NoticeDetail',
            component: () => import('@/components/content/NoticeDetail'),
        },
        {
            //FAQ
            path: '/faq',
            name: 'FAQ',
            component: () => import('@/components/content/FAQ'),
        },
        {
            //운영정책
            path: '/operation-policies',
            name: 'OperationPolicies',
            component: () => import('@/components/content/OperationPolicies'),
        },
        {
            //수익지급정책
            path: '/profit-policies',
            name: 'ProfitPolicies',
            component: () => import('@/components/content/ProfitPolicies'),
        },
        {
            //로그인
            path: '/login',
            name: 'Login',
            meta: {
                layout: 'auth'
            },
            component: require('@/components/user/Login').default,
        },
        {
            //회원가입: 약관동의
            path: '/signup/agreement',
            name: 'SignupAgreement',
            component: () => import('@/components/user/SignupAgreement'),
        },
        {
            //회원가입:정보입력
            path: '/signup/form',
            name: 'SignupForm',
            component: () => import('@/components/user/SignupForm'),
        },
        {
            //멸치패밀리 소개
            path: '/introduction',
            name: 'Introduction',
            component: () => import('@/components/content/Introduction'),
        },
        {
            //일거리현황
            path: '/jobs',
            name: 'JobList',
            beforeEnter: requireAuth(),
            component: () => import('@/components/job/JobList'),
        },
        {
            //일거리현황:상세
            path: '/jobs/:uuid',
            name: 'JobDetail',
            beforeEnter: requireAuth(),
            component: () => import('@/components/job/JobDetail'),
        },
        {
            //내 출품 현황
            path: '/my-entry-list',
            name: 'MyEntryList',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/MyEntryList'),
        },
        {
            //내 자산 현황
            path: '/my-asset',
            name: 'MyAsset',
            beforeEnter: requireAuth(),
            component: () => import('@/components/asset/MyAsset'),
        },
        {
            //경쟁현황 상세
            path: '/submission-detail/:uuid',
            name: 'SubmissionDetail',
            beforeEnter: requireAuth(),
            component: () => import('@/components/asset/SubmissionDetail'),
        },
        {
            //출금하기
            path: '/withdraw',
            name: 'Withdraw',
            beforeEnter: requireAuth(),
            component: () => import('@/components/asset/Withdraw'),
        },
        {
            //마이페이지 메인
            path: '/mypage',
            name: 'MyPage',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/MyPage'),
        },
        {
            //1:1문의: 리스트
            path: '/qna',
            name: 'QNAList',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/QNAList'),
        },
        {
            //1:1문의: 폼(신규)
            path: '/qna/form',
            name: 'QNAForm',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/QNAForm'),
        },
        {
            //1:1문의: 폼(수정)
            path: '/qna/form/:uuid',
            name: 'QNAEdit',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/QNAForm'),
            props: true
        },
        {
            //1:1문의: 상세보기
            path: '/qna/:uuid',
            name: 'QNADetail',
            beforeEnter: requireAuth(),
            component: () => import('@/components/user/QNADetail'),
        },
        {
            //비밀번호 찾기
            path: '/find-password',
            name: 'FindPassword',
            component: () => import('@/components/user/FindPassword'),
        },
        {
            //무료 오디오
            path: '/audio',
            name: 'AudioList', 
            component: () => import('@/components/audio/AudioList'),
        },
        {
            //무료 폰트
            path: '/font',
            name: 'FontList',
            component: () => import('@/components/font/FontList'),
        },
        {
            //인증메일 확인 페이지
            path: '/email-auth/:authcode',
            name: 'EmailAuth',
            component: () => import('@/components/user/EmailAuth'),
        },
        {
            //인증메일 재요청
            path: '/email-auth',
            name: 'EmailAuth',
            component: () => import('@/components/user/EmailAuth'),
        },
        {
            //회원가입 후 인증메일 안내 페이지
            path: '/signup/:type',
            name: 'EmailAuth',
            component: () => import('@/components/user/EmailAuth'),
        },
        {
            path: '*',
            name: 'Error',
            meta: {
                layout: 'error'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js